import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function HeroBanner() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="hero-banner" className="relative w-full py-32 min-h-[85vh] flex items-center justify-center overflow-hidden">
      {}
      <div className="absolute inset-0 w-full h-full">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1553131/img/israel_desert_landscape_hero.png" alt="Judean Desert Landscape" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-primary/60" />
      </div>

      {}
      <div ref={ref} className={`relative z-10 container mx-auto px-4 flex flex-col items-center text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
        <h1 className="text-white font-heading font-bold text-5xl leading-tight drop-shadow-lg tracking-tight !m-0 md:text-[64px]">
          Discover the Soul of the Holy Land
        </h1>

        <p className="text-white/95 font-sans text-lg md:text-[20px] italic font-light mb-12 max-w-2xl tracking-wide">
          "Walk where history breathes, through ancient paths and timeless stories written in stone."
        </p>

        <div className="flex flex-col sm:with-row gap-6 w-full sm:w-auto">
          <Button asChild className="h-14 px-8 text-lg border border-white bg-transparent text-white hover:bg-ring hover:border-ring hover:text-white transition-all duration-300 rounded-md">
            
          </Button>

          <Button asChild className="h-14 px-8 text-lg border border-white bg-transparent text-white hover:bg-ring hover:border-ring hover:text-white transition-all duration-300 rounded-md">
            
          </Button>
        </div>
      </div>
    </section>;
}